module.exports = __webpack_public_path__ + "img/galgal_no.a94e21bb.png";